import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgNewsOrNewsletter(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.14 93.135A10.138 10.138 0 0 1 12 82.995v-56.62h59.155v56.62c0 5.602 4.538 10.14 10.14 10.14H22.142Z"
        fill="#F1F5F9"
      />
      <path
        d="M99.71 43.276a8.275 8.275 0 0 0-8.273 8.274v31.445c0 5.594-4.547 10.14-10.141 10.14-5.595 0-10.141-4.546-10.141-10.14V43.276H99.71Z"
        fill="#E2E8F0"
      />
      <path
        d="M107.992 65.18H91.437V51.55a8.284 8.284 0 0 1 8.281-8.282A8.284 8.284 0 0 1 108 51.55v13.63h-.008Z"
        fill="#F1F5F9"
      />
      <path
        d="M90.636 82.995V56.628a.8.8 0 0 1 1.6 0v26.367c0 6.044-4.896 10.94-10.94 10.94a.8.8 0 1 1 0-1.6c5.16 0 9.34-4.18 9.34-9.34Z"
        fill="#0F172A"
      />
      <path d="M36.82 34.623H21.347v20.78H36.82v-20.78Z" fill="#CAE8DF" />
      <path
        d="M61.935 34.49a.8.8 0 1 1 0 1.6H43.082a.8.8 0 1 1 0-1.6h18.853ZM61.935 40.973a.8.8 0 1 1 0 1.6H43.082a.8.8 0 1 1 0-1.6h18.853ZM61.935 47.446a.8.8 0 1 1 0 1.6H43.082a.8.8 0 1 1 0-1.6h18.853ZM61.935 53.928a.8.8 0 1 1 0 1.6H43.082a.8.8 0 1 1 0-1.6h18.853ZM61.935 60.41a.8.8 0 1 1 0 1.599H21.347a.8.8 0 1 1 0-1.6h40.588ZM61.935 66.89a.8.8 0 1 1 0 1.6H21.347a.8.8 0 1 1 0-1.6h40.588ZM30.55 73.373a.8.8 0 0 1 0 1.6h-9.203a.8.8 0 1 1 0-1.6h9.203ZM30.55 79.854a.8.8 0 0 1 0 1.6h-9.203a.8.8 0 1 1 0-1.6h9.203Z"
        fill="#B3C0D0"
      />
      <path d="M62.62 73.522h-25.8v7.774h25.8v-7.774Z" fill="#CAE8DF" />
    </svg>
  )
}
export default wrapIllustration(SvgNewsOrNewsletter)
